import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { MeasureVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { IWizItemRenderer, WizLabel, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/** Renderer vignette d'une entité métier */
@Component({
  selector: 'measure-tree-renderer',
  templateUrl: './measure-tree.renderer.html'
})
export class MeasureTreeRenderer implements IWizItemRenderer<null, MeasureVO> {
  constructor(public elementRef: ElementRef) {}

  @HostBinding('class.is-selected') public get isSelected() {
    return  this.data === Model.getInstance().currentMeasure;
  }

  @ViewChild('lbTitle') lbTitle: WizLabel;
  @ViewChild('lbContent') lbContent: WizLabel;

  public showPen: boolean = false; // affichage du crayon d'édition, si éditable et mode I
  public showWeight: boolean = false; // affichage du poids si WeightGrid
  public showConstant: boolean = false; // affichage si constante
  public hasError: boolean = false; // erreur de formule

  public hasHiddenDependencies: boolean = false; // dépendances non affichées
  public hasHiddenLegacies: boolean = false; // héritages non affichés

  private _data: MeasureVO;
  public get data(): MeasureVO {
    return this._data;
  }
  @Input()
  public set data(data: MeasureVO) {
    this._data = data;
    this.showPen = Model.getInstance().measureEngine.isReallyEditable(data);

    this.showWeight = data.mode === WizConstants.MEASURE_MODE_WEIGHT_GRID;
    this.showConstant = data.mode === WizConstants.MEASURE_MODE_CONSTANT;
 
    this.hasError = false;
    this.hasHiddenLegacies = Model.getInstance().measureEngine.hasHiddenLegacies(Model.getInstance().measureEngine.currentFEI, data);
    this.hasHiddenDependencies = Model.getInstance().measureEngine.hasHiddenDependencies(Model.getInstance().measureEngine.currentFEI, data);
  }

  public get currentFormula(): string {
    return Model.getInstance().measureEngine.getMeasureCurrentFormulaByMode(this.data);
  }

  // click sur X pour supprimer la vignette du pool
  public doClose(event: Event): void {
    Model.getInstance().measureDS.removeSelectedItems([this.data]);
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_SHOW_HIDE, this.data));
  }

  // click sur < pour afficher toute la pile de dépendances
  public showDependencies(event: Event): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_DEPENDENCY, this.data));
  }

  // click sur < pour afficher toute la pile de dépendances
  public showLegacies(event: Event): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_LEGACY, this.data));
  }

  /** sélection / ou pas de la measure, depuis le graph */
  public selectMe(event: Event): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_SELECT, this.data));
  }

  /** double clic sur contenu du thumb, demande d'ouverture du panel de saisie de formule */
  public quickFormula(event: Event): void {
    if (this.data.isConstant || this.data.isWeight) {
    } else {
      WizEventManager.dispatchEvent(
        this.elementRef,
        new AlkEvent(ALK_EVENT_TYPE.MEASURE_SHOW_FORMULA_EDITOR, [
          this.data,
          Model.getInstance().currentFistMode,
          null,
        ])
      );
    }
  }
}
